import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Users } from "lucide-react";

export default function AdminWarehouseDispatchers() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/warehouse-dispatchers")
      .then(r => setRows(r.data))
      .catch(e => toast.error(formatApiError(e)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="admin-wh-disp-page" className="space-y-5">
      <div>
        <div className="text-xs font-mono-tech uppercase tracking-[0.2em] text-cyan-400 mb-1">/ Warehouse</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Warehouse Dispatchers</h1>
        <p className="text-slate-600 dark:text-slate-400 mt-1 text-sm">All warehouse-side dispatchers across every facility.</p>
      </div>
      {loading ? <div className="py-14 text-center text-slate-500">Loading…</div> :
       rows.length === 0 ? (
        <div className="border border-dashed border-slate-200 dark:border-slate-800 rounded-lg py-14 text-center bg-slate-100/30 dark:bg-slate-900/30 text-slate-500">
          <Users className="w-10 h-10 text-slate-700 mx-auto mb-3" /> No dispatchers yet.
        </div>
       ) : (
        <div className="border border-slate-200 dark:border-slate-800 rounded-lg overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-100/60 dark:bg-slate-900/60 text-[11px] font-mono-tech uppercase tracking-wider text-slate-500">
              <tr>
                <th className="text-left px-4 py-3">Name</th>
                <th className="text-left px-4 py-3">Email</th>
                <th className="text-left px-4 py-3">Warehouse</th>
                <th className="text-left px-4 py-3">Status</th>
                <th className="text-left px-4 py-3">Created</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 dark:divide-slate-800">
              {rows.map(d => (
                <tr key={d.id}>
                  <td className="px-4 py-3 font-medium">{d.full_name}</td>
                  <td className="px-4 py-3 text-slate-700 dark:text-slate-300">{d.email}</td>
                  <td className="px-4 py-3 text-slate-700 dark:text-slate-300">{d.warehouse_name}</td>
                  <td className="px-4 py-3"><span className={`text-[10px] uppercase font-mono-tech tracking-wider px-2 py-0.5 rounded border ${d.status === "ACTIVE" ? "bg-green-500/10 text-green-400 border-green-500/30" : "bg-slate-700/40 text-slate-700 dark:text-slate-300 border-slate-300 dark:border-slate-600"}`}>{d.status}</span></td>
                  <td className="px-4 py-3 text-xs text-slate-600 dark:text-slate-400">{new Date(d.created_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
       )}
    </div>
  );
}
